import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent {
  language: 'is' | 'en' = 'is'; // Default to Icelandic

  setLanguage(lang: 'is' | 'en') {
    this.language = lang;
  }
}